import { swNumberFilter } from "app/filters/ngFilters";
import SIDotsLoader from "app/pages/sales-intelligence/common-components/SIDotsLoader/SIDotsLoader";
import { StyledParenthesisedContent } from "app/pages/sales-intelligence/common-components/styles";

import type { ITabNumberOfResultsProps } from "./types";

const TabNumberOfResults = ({ total, isLoading, formatNumber = swNumberFilter() }: ITabNumberOfResultsProps) => {
    if (isLoading) {
        return <SIDotsLoader />;
    }

    return total ? <StyledParenthesisedContent>{formatNumber(total)}</StyledParenthesisedContent> : null;
};

export default TabNumberOfResults;
